/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Tree_Create_TitleInputs */

const en_statement_tree_create_title = /** @type {(inputs: Statement_Tree_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New statement tree`)
};

const nl_statement_tree_create_title = /** @type {(inputs: Statement_Tree_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe stamboom`)
};

/**
* | output |
* | --- |
* | "New statement tree" |
*
* @param {Statement_Tree_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_tree_create_title = /** @type {((inputs?: Statement_Tree_Create_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_Create_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_create_title(inputs)
	return en_statement_tree_create_title(inputs)
});